/**
 * 三款小游戏共用的固定步进循环（B，pet_arcade/core）。纯函数式的小对象：不碰计时器、不碰 DOM。
 *
 * UI 每帧把「这一帧过了多少毫秒」交进来；这里累加后按整步（默认 60 步／秒）推进，
 * 单帧最多记 MAX_FRAME_MS（切后台、卡顿回来不一次补跑几秒）。所以同一输入序列不论多少帧率喂进来，走的步数与结果都一样。
 * 用整数「微步」累加（1 步 = STEP_UNITS 个单位），避免浮点累加在不同帧率下差出一步。
 */

export const STEPS_PER_SECOND = 60;
export const STEP_MS = 1000 / STEPS_PER_SECOND;
export const MAX_FRAME_MS = 250;
const STEP_UNITS = 1000; // 每毫秒按 60 个单位记：1 步 = 1000 单位，1 毫秒 = 60 单位（整数，不丢精度）

export interface FixedStepClock {
  /** 喂一帧的时长，返回这一帧该走几步。暂停时由调用方别调或传 0。 */
  feed(frameMs: number): number;
  reset(): void;
}

export function createFixedStepClock(): FixedStepClock {
  let pending = 0; // 单位：1/60 毫秒；攒够 STEP_UNITS 走一步
  return {
    feed(frameMs: number): number {
      if (!Number.isFinite(frameMs) || frameMs <= 0) return 0;
      const clamped = Math.min(frameMs, MAX_FRAME_MS);
      pending += Math.round(clamped * STEPS_PER_SECOND);
      const steps = Math.floor(pending / STEP_UNITS);
      pending -= steps * STEP_UNITS;
      return steps;
    },
    reset(): void {
      pending = 0;
    },
  };
}
